
import { mapState } from 'vuex';
import Gallery from './components/Gallery';

export default {
  i18nComponentKey: 'WidgetProductReviewsGallery.WidgetProductReviewsGalleryMobile',
  name: 'WidgetProductReviewsGalleryMobile',
  components: { Gallery },
  computed: {
    ...mapState('widget', ['widget']),
    galleryProps() {
      return { rowGap: 32, ...this.reviewLayoutProps };
    },
    reviewLayoutProps() {
      switch (this.widget.posts_per_line) {
        case 2:
          return { cols: 2, gutter: 16 };
        case 3:
          return { cols: 3, gutter: 14 };
        default:
          return { cols: 1, gutter: 0 };
      }
    }
  }
};
